import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import Home from './Home';
import Panel from './Panel';
import Details from './Details';
import ThankYou from './ThankYou';
import TopPaidSurveys from './TopPaidSurveys';

import './App.css'

const App = () => (
  <Router>
    <div>
      {/* A <Switch> looks through its children <Route>s and
          renders the first one that matches the current URL. */}
      <Switch>
        <Route path="/panel">
          <Panel />
        </Route>
        <Route path="/details">
          <Details />
        </Route>
        <Route path="/thank-you">
          <ThankYou />
        </Route>
        <Route path="/top-paid-surveys">
          <TopPaidSurveys />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
    </div>
  </Router>
);

export default App;
